export default "__VITE_ASSET__CII9cSHV__"